module.exports = __webpack_public_path__ + "img/icon_people.7f18782c.svg";